import * as React from "react";
import { StakeInputData } from "../../../../data/models";
import { StakeHolder } from "../StakeHolder";
import { Dropdown, DropdownData } from "sb-resp-ui";

export class StakeType extends React.Component<{
    isFreeBetView: boolean
    stakeData: StakeInputData
    freebetData: DropdownData
    dropdownHandler: Function
    defaultText: string
}, {}> {
    render() {
        return (
            this.props.isFreeBetView
                ? <Dropdown data={this.props.freebetData} selectItem={this.props.dropdownHandler} blockName="pulse-bet" defaultText={this.props.defaultText} />
                : <StakeHolder data={this.props.stakeData} />
        )
    }
}